exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".mobile-title-text[data-v-2f34a63e]{font-size:1.38rem;font-weight:400;color:#00202f}.mobile-subtitle-text[data-v-2f34a63e]{font-size:1.12rem;font-weight:300;color:#00202f}", "", {"version":3,"sources":["/home/ponce-dev-staging/report/src/components/Audits/AuditsDemo.vue"],"names":[],"mappings":"AACA,oCACE,kBAAmB,AACnB,gBAAiB,AACjB,aAAe,CAChB,AACD,uCACE,kBAAmB,AACnB,gBAAiB,AACjB,aAAe,CAChB","file":"AuditsDemo.vue","sourcesContent":["\n.mobile-title-text[data-v-2f34a63e] {\n  font-size: 1.38rem;\n  font-weight: 400;\n  color: #00202F;\n}\n.mobile-subtitle-text[data-v-2f34a63e] {\n  font-size: 1.12rem;\n  font-weight: 300;\n  color: #00202F;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f34a63e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Audits/AuditsDemo.vue
// module id = 1508
// module chunks = 0